import { render, staticRenderFns } from "./editResourceSupplier.vue?vue&type=template&id=07248bc8"
import script from "./editResourceSupplier.vue?vue&type=script&lang=js"
export * from "./editResourceSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports